// Build-time settings, defined by scripts/build.mjs from Netlify's settings per context (or a local
// .env). The URL and the publishable key are public by design; no secret reaches the browser.
export const ENV = {
  supabaseUrl: import.meta.env.HUB_SUPABASE_URL,
  publishableKey: import.meta.env.HUB_SUPABASE_PUBLISHABLE_KEY,
  // Netlify's CONTEXT: production, deploy-preview, branch-deploy; 'local' on a laptop
  context: import.meta.env.HUB_CONTEXT,
  notMovedIn: import.meta.env.HUB_NOT_MOVED_IN.split(',').map(s => s.trim()).filter(Boolean),
}

export const CONFIGURED = Boolean(ENV.supabaseUrl && ENV.publishableKey)
